import { useEffect, useState, FC } from "react";

export interface SearchInputProps {
  className?: string;
  value?: number;
  defaultValue?: number;
  min?: number;
  max?: number;
  onChange?: (value: number) => void;
  label?: string;
  desc?: string;
}

const SearchInput: FC<SearchInputProps> = ({
  className = "w-full",
  value,
  defaultValue = 0,
  min = 0,
  max,
  onChange,
  label,
  desc,
}) => {
  const [internalValue, setInternalValue] = useState(defaultValue);

  useEffect(() => {
    if (value !== undefined) {
      setInternalValue(value);
    }
  }, [value]);

  const handleClickDecrement = () => {
    if (internalValue <= min) return;
    setInternalValue((prev) => {
      const newValue = prev - 1;
      onChange && onChange(newValue);
      return newValue;
    });
  };

  const handleClickIncrement = () => {
    if (max !== undefined && internalValue >= max) return;
    setInternalValue((prev) => {
      const newValue = prev + 1;
      onChange && onChange(newValue);
      return newValue;
    });
  };

  return (
    <div
      className={`nc-NcInputNumber flex items-center justify-between space-x-5 ${className}`}
    >
      {label && <span className="font-medium">{label}</span>}
      <div className="flex items-center space-x-4">
        <button
          className="w-8 h-8 rounded-full border border-gray-400"
          type="button"
          onClick={handleClickDecrement}
          disabled={internalValue <= min}
        >
          -
        </button>
        <span>{internalValue}</span>
        <button
          className="w-8 h-8 rounded-full border border-gray-400"
          type="button"
          onClick={handleClickIncrement}
          disabled={max !== undefined && internalValue >= max}
        >
          +
        </button>
      </div>
    </div>
  );
};

export default SearchInput;
